import { render } from "./InternalMarkets.vue?vue&type=template&id=5ac94679&scoped=true"
import script from "./InternalMarkets.vue?vue&type=script&lang=js"
export * from "./InternalMarkets.vue?vue&type=script&lang=js"

import "./InternalMarkets.vue?vue&type=style&index=0&id=5ac94679&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac94679"]])

export default __exports__